export type Language = 'en' | 'ua' | 'ru';

export type StrapiLanguage = 'en' | 'uk' | 'ru' | 'all';

export const translate = (
	lang: Language,
	translations: Record<Language, string>,
) => translations[lang] ?? null;
